import type { IngestionDatasetProgress } from '../../api/types.ts';

/** Keep rows visible at startup without presenting the previous run as complete. */
export function ingestionProgressRows(
  datasets: readonly IngestionDatasetProgress[],
  awaitingRun: boolean,
): IngestionDatasetProgress[] {
  if (!awaitingRun) return [...datasets];
  return datasets.map(dataset => ({
    name: dataset.name,
    display_name: dataset.display_name,
    column_count: dataset.column_count,
    total_rows: dataset.total_rows,
    row_count: 0,
    stage: 'pending',
    progress: 0,
    message: 'Waiting to sync',
  }));
}